export default __webpack_public_path__ + "static/media/ProductPageImage02.9a3683ff.jpg";